import client from "@/utils/apiClient.js";

class RankingApiService {
    getAccessRanking(formtype, params) {
        /*
        if (formtype == "PAPER") {
            return client.get("/json/tests/ranking_access_paper.json");
        } else if (formtype == "HINSHU") {
            return client.get("/json/tests/ranking_access_hinshu.json");
        } else if (formtype == "NOUKIGU") {
            return client.get("/json/tests/ranking_access_noukigu.json");
        }
        */
        return client.get("/ranking/access/" + formtype, params);
    }

    getKeywordRanking(formtype, params) {
        /*
        if (formtype == "ALL") {
            return client.get("/json/tests/ranking_keyword_all.json");
        } else if (formtype == "PAPER") {
            return client.get("/json/tests/ranking_keyword_paper.json");
        } else if (formtype == "HINSHU") {
            return client.get("/json/tests/ranking_keyword_hinshu.json");
        } else if (formtype == "NOUKIGU") {
            return client.get("/json/tests/ranking_keyword_noukigu.json");
        }
        return client.get("/json/ranking.json");
        */
        return client.get("/ranking/keyword/" + formtype, params);
    }
}

export default new RankingApiService();
